import React from 'react'
import PropTypes from 'prop-types'
import AccordionContext from './AccordionContext'
import AccordionSection from './AccordionSection'

const modes = {
  single: 'single', // Only show at most one accordion section at a time
  multiple: 'multiple', // Can show multiple accordion section at a time
  constantlySingle: 'constantlySingle' // Always show exactly on accordion section at a time
}

class Accordion extends React.PureComponent {
  static propTypes = {
    Container: PropTypes.oneOfType([ PropTypes.func, PropTypes.object, PropTypes.symbol, PropTypes.string ]),
    showOnMount: PropTypes.oneOfType([ PropTypes.array, PropTypes.string, PropTypes.number ]),
    mode: PropTypes.oneOf(Object.keys(modes))
  }

  static defaultProps = {
    Container: React.Fragment,
    showOnMount: [],
    mode: modes.single
  }

  static modes = modes

  constructor (props) {
    super(props)
    this.state = {
      show: Array.isArray(props.showOnMount) ? props.showOnMount : [ props.showOnMount ],
      onClick: this.onSectionClick,
      registerSection: this.registerSection,
      sectionList: []
    }
  }

  registerSection = (id) => {
    this.setState(
      ({ sectionList, ...state }) => ({ ...state, sectionList: sectionList.concat([id]) })
    )

    // Function to unregister section
    return () => {
      this.setState(
        ({ sectionList, ...state }) => ({ ...state, sectionList: sectionList.filter(e => e !== id) })
      )
    }
  }

  onSectionClick = (sectionId) => {
    const { show } = this.state
    const { mode } = this.props
    const modes = Accordion.modes
    if (show.indexOf(sectionId) > -1) {
      if (mode !== modes.constantlySingle) {
        this.setState({ show: show.filter(e => e !== sectionId) })
      }
    } else {
      if (mode !== modes.multiple) {
        this.setState({ show: [sectionId] })
      } else {
        this.setState({ show: show.concat([sectionId]) })
      }
    }
  }

  render () {
    const { Container, children } = this.props

    return (
      <AccordionContext.Provider value={this.state}>
        <Container>
          {typeof children === 'function'
            ? children(this.state)
            : children}
        </Container>
      </AccordionContext.Provider>
    )
  }
}

Accordion.Section = AccordionSection

export default Accordion
